import React from "react"
import { useDispatch } from "react-redux"
import { deleteClosedTab } from "store/actions"
import { useNavigate, useParams } from "react-router-dom"
import ChatSourceIcon from "components/Common/ChatSourceIcon"

function Tab({ children, name, index, openChatsTabs, tab }) {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const params = useParams()
  const getTabKey = chat => chat?._id || chat?.client
  const tabKey = getTabKey(tab)
  const tabLabel =
    name && name !== "undefined" && name !== "null"
      ? name
      : tab?.contactName?.number || tab?.client || "Unknown Chat"

  const handleOnClick = (e, tab) => {
    e.stopPropagation()
    const currentTabKey = getTabKey(tab)

    if (!currentTabKey) return

    if (currentTabKey === params.id) {
      if (openChatsTabs.length === 1) {
        navigate(`/`)
      } else {
        openChatsTabs[index - 1]
          ? navigate(`/chat/${getTabKey(openChatsTabs[index - 1])}`)
          : navigate(`/chat/${getTabKey(openChatsTabs[index + 1])}`)
      }

      dispatch(deleteClosedTab(currentTabKey))
      return
    } else {
      dispatch(deleteClosedTab(currentTabKey))
      return
    }
  }

  return (
    <div
      className={`tab ${tabKey === params.id && "active"}`}
      onClick={() => tabKey && navigate(`/chat/${tabKey}`)}
    >
      <span className="tab-status align-self-center d-flex justify-content-center align-items-center">
        {children}
      </span>

      <span className="tab-name align-self-center">
        <ChatSourceIcon chat={tab} className="chat-source-icon-tab" />
        {tabLabel
          ? tabLabel?.length > 10
            ? tabLabel?.substring(0, 10) + "..."
            : tabLabel
          : tab?.contactName?.number}
      </span>

      <span
        onClick={e => handleOnClick(e, tab)}
        className="tab-close align-self-center d-flex justify-content-center align-items-center"
      >
        <i className="mdi mdi-close"></i>
      </span>
    </div>
  )
}

export default Tab
